import React, { useState } from 'react';
// External components
import { Row } from 'react-simple-flex-grid';
// Components
//import IoAutoComplete from '../../common/IoAutoComplete/IoAutoComplete.jsx';
import Header from '../../common/Header/Header.jsx';


function SearchFilterPanel({
    gpsButtonTapped,
    filtersChanged,
    typographyItems
}) {
    const [selectedLocation, setSelectedLocation] = useState({ geographicId: 0, displayName: ''});

    const handleInputChange = (name, id, innerText) => {
        if (name === 'locations') {
            filtersChanged(id, value);
        }
        setSelectedLocation({
            geographicId: id,
            displayName: innerText
        });
    }

    const renderTypographics = () => {
        return Object.keys(typographyItems).map(key => {
            if (typographyItems[key].frameItemTypeName == 'Header') {
                return <Header key={key} color="#525252" As="h4">{typographyItems[key].textContent}</Header>
            }
            if (typographyItems[key].frameItemTypeName == 'Sub-Header') {
                return <Header key={key} color="#525252" As="h6">{typographyItems[key].textContent}</Header>
            }
        });
    }

    return (
        <div>
            {renderTypographics()}
            {/* <IoAutoComplete
                name="locations"
                value={selectedLocation['geographicId']}
                displayName={selectedLocation['displayName']}
                displayValue={selectedLocation['displayName']}
                handleInputChange={handleInputChange}
                autoCompleteType="db"
                hasSiteId={false}
                tableName="iocontentdb.geographics"
                idField="geographicId"
                nameAttr="displayName"
                placeholder="Where are you going?"
            /> */}
        </div>
    )
}

export default SearchFilterPanel;
